import { Controller } from '@hotwired/stimulus';

// /tools hub — highlight rail link for the section in view.
export default class extends Controller {
  static targets = ['link', 'section'];

  connect() {
    this.scrollOffset = 120;
    this.onScroll = this.syncActive.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.syncActive();
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll);
  }

  jump(event) {
    const href = event.currentTarget.getAttribute('href');
    if (!href?.startsWith('#')) return;

    const el = document.querySelector(href);
    if (!el) return;

    event.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', href);
    this.setActive(href.slice(1));
  }

  syncActive() {
    let current = this.sectionTargets[0]?.id;

    this.sectionTargets.forEach((section) => {
      const top = section.getBoundingClientRect().top;
      if (top <= this.scrollOffset) current = section.id;
    });

    if (current) this.setActive(current);
  }

  setActive(id) {
    this.linkTargets.forEach((link) => {
      const active = link.getAttribute('href') === `#${id}`;
      link.classList.toggle('is-active', active);
    });
  }
}
